export const UPDATE_FORM = "UPDATE_FORM_DIETITIAN";
export const RESET_FORM = "RESET_FORM_DIETITIAN";

export const updateForm = (formData) => {
    return (dispatch) => {
        dispatch({
            type: UPDATE_FORM,
            payload: formData,
        });
    };
};

export const resetForm = () => {
    return (dispatch) => {
        dispatch({
            type: RESET_FORM,
        });
    };
};
